/* eslint-disable no-prototype-builtins */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/button-has-type */
/* eslint-disable react/require-default-props */
/* eslint-disable react/sort-comp */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookie from 'universal-cookie';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';

import { setWalletBalance } from '../../reducers/main';
import { setTransactions } from '../../reducers/transactions';
import apiCaller from '../../utils/apiCaller';

const cookies = new Cookie();

const defaultButton = props => (
  <Button {...props} color="info">
    {props.children}
  </Button>
);
const style = {
  customCardContentClass: {
    paddingLeft: '0',
    paddingRight: '0',
  },
  cardIconTitle: {
    marginTop: '15px',
    marginBottom: '0px',
  },
};

class Pagination extends React.Component {
  constructor(props) {
    super();
    this.changePage = this.changePage.bind(this);
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
  };

  componentDidMount() {
    this.getTransactionList();
  }

  getTransactionList() {
    const role = cookies.get('role');
    const transactionData = [];
    const body = {
      total_items: 30,
    };
    let nextCursorId = null;
    let path = '';
    if (role !== 'super_admin') {
      path = 'premium-api/read-payout-list';
    } else {
      path = 'premium-api/read-all-premium-payout-list';
      body.from_date = null;
      body.to_date = null;
    }
    apiCaller(path, 'post', body, true, false)
      .then(response => {
        if (response.items.length !== 0) {
          response.items.forEach(dataList => {
            if (
              response.hasOwnProperty('LastEvaluatedKey') &&
              response.LastEvaluatedKey !== null
            ) {
              nextCursorId = response.LastEvaluatedKey;
            }
            if (dataList.payin !== true) {
              transactionData.push({
                color: 'success',
                data: [
                  moment
                    .unix(dataList.created_at)
                    .format('DD-MM-YYYY hh:mm:ss'),
                  dataList.serial_index || '___',
                  dataList.amount || '___',
                  dataList.account_number || '___',
                  dataList.status || '___',
                  dataList.truck_number || '___',
                  dataList.vendor_name || '___',
                  dataList.service_provider_utr || '___',
                  dataList.premium_transporter_id || '___',
                  dataList.user_id || '___',
                  dataList.reference_number || '___',
                  dataList.from_city || '___',
                  dataList.to_city || '___',
                  dataList.ifsc || '___',
                  dataList.date || '___',
                  dataList.notes || '___',
                ],
                dataList,
              });
            }
          });
          this.props.setTransactions(transactionData, nextCursorId);
          setTimeout(() => {
            if (
              response.hasOwnProperty('LastEvaluatedKey') &&
              response.LastEvaluatedKey !== null
            ) {
              this.getNextTransactions();
            }
          }, 1000);
        } else {
          this.props.setTransactions([], nextCursorId);
        }
      })
      .catch(err => {});
  }

  componentWillReceiveProps(nextProps) {
    this.changePage(nextProps.page + 1);
  }

  changePage(page) {
    const activePage = this.props.page + 1;
    if (page === activePage) {
      return;
    }

    this.props.onPageChange(page - 1);
  }

  onNext(activePage) {
    // if (activePage === this.props.pages) return;
    if (this.props.lastEvaluatedKey !== null) {
      this.getNextTransactions();
    }
    this.changePage(activePage + 1);
  }

  getNextTransactions() {
    const role = cookies.get('role');
    const { lastEvaluatedKey, transactions } = this.props;
    const transactionData = JSON.parse(JSON.stringify(transactions));
    const body = {
      total_items: 30,
    };
    if (lastEvaluatedKey !== '' && lastEvaluatedKey !== null) {
      body.LastEvaluatedKey = lastEvaluatedKey;
    }
    let nextCursorId = null;
    let path = '';
    if (role !== 'super_admin') {
      path = 'premium-api/read-payout-list';
    } else {
      path = 'premium-api/read-all-premium-payout-list';
      body.from_date = null;
      body.to_date = null;
    }
    apiCaller(path, 'post', body, true, false)
      .then(response => {
        if (response.items.length !== 0) {
          response.items.forEach(dataList => {
            if (
              response.hasOwnProperty('LastEvaluatedKey') &&
              response.LastEvaluatedKey !== null
            ) {
              nextCursorId = response.LastEvaluatedKey;
            }
            if (dataList.payin !== true) {
              transactionData.push({
                color: 'success',
                data: [
                  moment
                    .unix(dataList.created_at)
                    .format('DD-MM-YYYY hh:mm:ss'),
                  dataList.serial_index || '___',
                  dataList.amount || '___',
                  dataList.account_number || '___',
                  dataList.status || '___',
                  dataList.truck_number || '___',
                  dataList.vendor_name || '___',
                  dataList.service_provider_utr || '___',
                  dataList.premium_transporter_id || '___',
                  dataList.user_id || '___',
                  dataList.reference_number || '___',
                  dataList.from_city || '___',
                  dataList.to_city || '___',
                  dataList.ifsc || '___',
                  dataList.date || '___',
                  dataList.notes || '___',
                ],
                dataList,
              });
            }
          });
          this.props.setTransactions(transactionData, nextCursorId);
        } else {
          this.props.setTransactions(transactionData, nextCursorId);
        }
      })
      .catch(err => {});
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const activePage = this.props.page + 1;
    return (
      <GridContainer justify="center">
        <GridItem xs={6} sm={6} md={6}>
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === 1) return;
              this.changePage(activePage - 1);
            }}
            disabled={activePage === 1}
          >
            {this.props.previousText}
          </PageButtonComponent>
        </GridItem>

        <GridItem xs={6} sm={6} md={6}>
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              //   if (activePage === this.props.pages) return;
              this.onNext(activePage);
            }}
            disabled={
              (this.props.lastEvaluatedKey === '' ||
                this.props.lastEvaluatedKey === null) &&
              activePage === this.props.pages
            }
            style={{ float: 'right' }}
          >
            {this.props.nextText}
          </PageButtonComponent>
        </GridItem>
      </GridContainer>
    );
  }
}

Pagination.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setWalletBalance,
      setTransactions,
    },
    dispatch
  );

const mapStateToProps = state => ({
  walletBalance: state.main.walletBalance,
  transactions: state.transactions.transactions,
  lastEvaluatedKey: state.transactions.lastEvaluatedKey,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(Pagination));
